import dayjs from 'dayjs';
import { DateUtils } from '@jaam/commons';

type ItemGroup = Record<string, any[]>;

type OrderBy = 'year' | 'month' | 'day';

const orderByMap: Record<OrderBy, dayjs.ManipulateType> = {
  year: 'year',
  month: 'month',
  day: 'day',
};

const dateFormatMap: Record<OrderBy, string> = {
  year: 'YYYY',
  month: 'MMMM YYYY',
  day: 'DD MMMM YYYY',
};

export function isValidDateString(
  value: string,
  originalValue: any,
): string | Date {
  const parsedDate = DateUtils(
    originalValue,
    'YYYY-MM-DD',
    'fr',
    true,
  ).isValid();
  if (parsedDate) {
    return DateUtils(originalValue, 'YYYY-MM-DD').toDate();
  }
  return originalValue;
}

export const groupDataByDate = (
  data: any[],
  dateField: string,
  orderBy: OrderBy = 'day',
): ItemGroup => {
  const DATE_FORMAT = dateFormatMap[orderBy];

  const sortedData = [...data].sort((a, b) => {
    const timeA = a[dateField] ? DateUtils(a[dateField]).valueOf() : 0;
    const timeB = b[dateField] ? DateUtils(b[dateField]).valueOf() : 0;
    return timeB - timeA;
  });

  return sortedData.reduce((acc, item) => {
    const dateValue = item[dateField];
    if (dateValue) {
      const date = DateUtils(dateValue);
      const key = date.endOf(orderByMap[orderBy]).format(DATE_FORMAT);
      acc[key] = acc[key] || [];
      acc[key].push(item);
    }
    return acc;
  }, {} as ItemGroup);
};
